import React from 'react';
import { useTranslation } from 'hooks';
import './labelStatus.scss';

interface Props {
  text: string;
  status?:
    | 'success'
    | 'active'
    | 'info'
    | 'error'
    | 'warning'
    | 'processing'
    | 'blackline';
  customClass?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const LabelStatus: React.FC<Props> = ({
  text,
  status,
  customClass = '',
  onClick,
}) => {
  const getTranslate = useTranslation();
  return (
    <div
      className={`ui-label-status ui-label-status_${status} ${customClass}`}
      onClick={onClick}>
      <span className='utils-overflow-dots'>
        {getTranslate(text).toLowerCase()}
      </span>
    </div>
  );
};

export default LabelStatus;
